import axios from 'axios';

export default {
    methods: {
        async microProveedorBuscar(d, ok, err) {
            try {
                let r = await axios.post('proveedor/micro-buscar', d);
                ok(r.data)
            } catch (r) {
                err(r)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/micro/proveedores.js